import React, { PureComponent } from "react";
import t from "@zendesk/client-i18n-tools";

import styles from "./styles.css";

export default class SearchFailure extends PureComponent {
  render() {
    return (
      <div
        className={styles.searchFailure}
        data-test-id="article-matches-search-failure"
      >
        {t("knowledge-verification.searchFailure")}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ArticleMatches/SearchFailure.js